// Copyright (c) Docugami, Inc. All rights reserved.

import { useSelector } from "react-redux"
import { AppState } from "store"
import { FeatureFlags } from "store/featureFlags/types"

export function useFeatureFlag(flag: FeatureFlags): boolean {
    const isEnabled = useSelector((state: AppState) => state.featureFlags.featureFlags[flag]);
    return isEnabled;
}
